import { useQuery } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { CancellationRequest } from "../../types/Types";

export function useGetCancellationRequestDetail(id: number | null, enabled: boolean) {
  return useQuery({
    enabled: enabled && id != null,
    queryKey: ["cancellation-request-detail", id],
    queryFn: async () => {
      const url = getAPIURL(`/Admin/Cancellations/${id}`);
      const res = await axiosInstance<CancellationRequest>(url);
      return res.data;
    },
  });
}
